import { combineEpics } from "redux-observable";
import { epicLoadOutskirtBuildingOnUpgrade } from "./epics/epicLoadOutskirtBuildingOnUpgrade";
import { epicLoadOutskirtBuildings } from "./epics/epicLoadOutskirtBuildings";
import { epicLoadOutskirtsInfo } from "./epics/epicLoadOutskirtsInfo";
import { epicOutskirtBuildingDeselect } from "./epics/epicOutskirtBuildingDeselect";
import { epicOutskirtBuildingUpgrade } from "./epics/epicOutskirtBuildingUpgrade";
import { epicOutskirtBuildingUpgradeRequest } from "./epics/epicOutskirtBuildingUpgradeRequest";
export var epicOutskirtsInfo = combineEpics(epicOutskirtBuildingUpgrade, epicLoadOutskirtBuildings, epicLoadOutskirtBuildingOnUpgrade, epicLoadOutskirtsInfo, epicOutskirtBuildingUpgradeRequest, epicOutskirtBuildingDeselect);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epicOutskirtsInfo.ts
// module id = 1914
// module chunks = 3